import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propStr } from '../../../../../../helpers/custom-prop-types';
import SlideSearchShareIcon from '../../../../../Icon/Svg/SlideSearchShareIcon';
/**
 * データが存在しない場合に表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchShareStatusTabContentEmpty = (props) => {
    const { className, text } = props;
    return (_jsx("div", Object.assign({ className: clsx('slide_search_share_status_tab_empty', className) }, { children: _jsxs("div", Object.assign({ className: 'item_inner' }, { children: [_jsx("div", Object.assign({ className: 'item_icon' }, { children: _jsx(SlideSearchShareIcon, { className: 'icon_svg' }) })), _jsx("span", Object.assign({ className: 'item_text' }, { children: text }))] })) })));
};
SlideSearchShareStatusTabContentEmpty.propTypes = {
    className: propStr(),
    text: propStr().isRequired,
};
SlideSearchShareStatusTabContentEmpty.defaultProps = {
    className: '',
};
export default SlideSearchShareStatusTabContentEmpty;
